<template>
  <div class="match">
    <div v-html="content"></div>
  </div>
</template>

<script>
import api from '@/api/aboutGMAT.js'
export default{
  data(){
    return{
      content:''
    }
  },
  mounted(){
    let params = {
      type:'grammar'
    }
    let query = this.$qs.stringify(params)
    api.studyGuide(query).then(res => {
      this.content = res.data.data.content
    })
    .catch(err => {
      this.$message.error('数据请求失败')
    })
  }
}
</script>

<style scoped>
.match{
  padding: 30px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/view/opporTunity/about/grammar.vue